"use client"

import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { useTranslate } from "@tolgee/react"
import { useState } from "react"

type NavLink = { label: string; href: string }

type NavItem = {
  key: string
  label: string
  href: string
  children?: NavLink[]
}

export const BarebonesNav = () => {
  const { t } = useTranslate()
  const [openKey, setOpenKey] = useState<string | null>(null)

  const items: NavItem[] = [
    {
      key: "shop",
      label: t("barebones_nav.shop", "Shop"),
      href: "/categories",
      children: [
        { label: t("barebones_nav.shop_all", "Shop All"), href: "/categories" },
        {
          label: t("barebones_nav.off_road_essentials", "Off-Road Essentials"),
          href: "/collections/off-road-essentials",
        },
        {
          label: t("barebones_nav.camp_and_trail", "Camp & Trail"),
          href: "/collections/camp-and-trail",
        },
        {
          label: t("barebones_nav.wishlist", "Wishlist"),
          href: "/user/wishlist",
        },
        {
          label: t("barebones_nav.outlet", "Outlet"),
          href: "/outlet",
        },
      ],
    },
    {
      key: "explore",
      label: t("barebones_nav.explore", "Explore"),
      href: "/categories/off-road-accessories",
      children: [
        {
          label: t(
            "barebones_nav.off_road_accessories",
            "Off-Road Accessories"
          ),
          href: "/categories/off-road-accessories",
        },
        {
          label: t("barebones_nav.camping_equipment", "Camping Equipment"),
          href: "/categories/camping-equipment",
        },
      ],
    },
    {
      key: "about",
      label: t("barebones_nav.about_us", "About Us"),
      href: "/our-story",
    },
    {
      key: "outlet",
      label: t("barebones_nav.outlet", "Outlet"),
      href: "/outlet",
    },
  ]

  return (
    <nav className="flex items-center gap-7" aria-label="Primary">
      {items.map((item) => {
        const open = openKey === item.key
        const hasChildren = Boolean(item.children?.length)

        return (
          <div
            key={item.key}
            className="relative"
            onMouseEnter={() => hasChildren && setOpenKey(item.key)}
            onMouseLeave={() => setOpenKey(null)}
          >
            <LocalizedClientLink
              href={item.href}
              className="bb-nav-link text-[12px] uppercase tracking-[0.16em] text-[#2b2118] transition-opacity hover:opacity-70"
              aria-expanded={hasChildren ? open : undefined}
              aria-haspopup={hasChildren ? "menu" : undefined}
            >
              {item.label}
            </LocalizedClientLink>

            {hasChildren && (
              <div
                className={`bb-dropdown absolute left-0 top-full z-50 pt-3 ${
                  open ? "bb-dropdown--open" : ""
                }`}
                aria-hidden={!open}
              >
                <div role="menu" className="bb-dropdown-panel min-w-[220px]">
                  {item.children!.map((child) => (
                    <LocalizedClientLink
                      key={child.href + child.label}
                      href={child.href}
                      role="menuitem"
                      className="bb-dropdown-item"
                      tabIndex={open ? 0 : -1}
                    >
                      {child.label}
                    </LocalizedClientLink>
                  ))}
                </div>
              </div>
            )}
          </div>
        )
      })}
    </nav>
  )
}
